import * as React from "react";

const SvgIcnAlert = (props: React.SVGProps<SVGSVGElement>) => (
    <svg width="1em" height="1em" viewBox="0 0 24 24" {...props}>
        <g stroke="none" strokeWidth={1} fill="none" fillRule="evenodd">
            <path d="M0 0h24v24H0z" />
            <path
                d="M12 4c1.462 0 2.814.365 4.058 1.096a7.582 7.582 0 012.846 2.846A7.868 7.868 0 0120 12a7.868 7.868 0 01-1.096 4.058 7.582 7.582 0 01-2.846 2.846A7.868 7.868 0 0112 20a7.868 7.868 0 01-4.058-1.096 7.726 7.726 0 01-2.846-2.866A7.833 7.833 0 014 12c0-1.449.365-2.795 1.096-4.038a7.873 7.873 0 012.866-2.866A7.833 7.833 0 0112 4zm0 13a1 1 0 100-2 1 1 0 000 2zm0-10a1 1 0 00-1 1v5a1 1 0 002 0V8a1 1 0 00-1-1z"
                fill="currentcolor"
            />
        </g>
    </svg>
);

export default SvgIcnAlert;
